import React, { useState } from "react";
import { Player } from "video-react";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../PdfViewer/PdfViewer";
import { IP } from "../../../../internalServer";
import ZoomableImage from "../../Pending/QuestionTypes/ZoomableImage";

export default function CheckBoxType({ questionNo, response }) {
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [mideaviewer, setMideaviewer] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
    setIsOpen(null)
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const truncate = (text, max = 20) =>
    text?.length > max ? text.slice(0, max) + "..." : text;

  const handleClickforpdf = (fileUrl) => {
    setTimeout(() => {
      setResponseAttach(fileUrl);
      setMideaviewer(true);
    }, 100)
  };

  const getExtension = (file = "") =>
    file?.split(".").pop()?.toLowerCase();

  const isImage = (ext) =>
    ["jpg", "jpeg", "png", "gif", "webp"]?.includes(ext);

  const getFileName = (file = "") =>
    file?.replace(/^[^_]*_/, "");


  const poster =
    "https://images.unsplash.com/photo-1431499012454-31a9601150c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. &nbsp;
            {response?.question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
          </div>
          {/* <div className="marksQue">
            {response?.question?.correct_score} Marks
          </div> */}
        </div>
        {response?.question?.attachments?.length > 0 &&
          response.question.attachments.map((attachment, index) => {
            const ext = getExtension(attachment);
            const fileName = getFileName(attachment);
            const fileUrl = IP + attachment.replace(/^\./, "");

            return (
              <div key={index}>
                {isImage(ext) ? (
                  <img
                    style={{ cursor: "pointer" }}
                    className="mt-3 imageWidthAndHeight"
                    src={fileUrl}
                    alt="Attachment"
                    onClick={() => {
                      if (!isError) handleClick(attachment);
                    }}
                  />
                ) : (
                  <div
                    className="mt-2"
                    onClick={() => handleClickforpdf(attachment)}
                  >
                    <div className="d-flex pdfContainer gap-2 p-2">
                      <div className="d-flex align-items-center">
                        <img
                          className="extention_icon"
                          src={
                            iconData?.find((i) => i.extension === ext)?.icon ||
                            "/images/file-icon.svg" // fallback icon
                          }
                          alt=""
                        />
                      </div>

                      <div className="w-100">
                        <div className="pdfNameAssessment" title={fileName}>
                          {fileName.length > 20
                            ? `${fileName.slice(0, 20)}...`
                            : fileName}
                        </div>
                        <div className="pdfFileSize">12 KB</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}

        <div className=" optionContainer mt-4 ml-2">
          {response?.question?.options?.length > 0 &&
            response?.question?.options?.map((option, index) => {
              return (
                <>
                  <div
                    key={option.key}
                    className="d-flex justify-content-between align-items-center mt-2"
                  >
                    <div className="d-flex gap-3 ">
                      <div>
                        {
                          option?.key + ".  "
                        }
                        <input
                          type="checkbox"
                          className="hwCheckbox ml-1"
                          readOnly
                          checked={option?.key === response?.answer?.key}
                        />
                      </div>
                      <div
                        className={` ${option?.key === response?.answer?.key
                          ? "QueOptionsChecked"
                          : "QueOptions"
                          }`}
                      >
                        {option?.value}
                      </div>
                    </div>
                    {option?.key === response?.answer?.key && (
                      <div className="yourAnswer">Your answer</div>
                    )}
                  </div>
                  <div className="ml-6">
                    {/* {option.attachment &&
                      (() => {
                        const ext = option.attachment.split(".").pop().toLowerCase();
                        const isImage = ["jpg", "jpeg", "png"].includes(ext);
                        return isImage ? (
                          <ZoomableImage src={option.attachment} />
                        ) : null;
                      })()} */}
                    {option.attachment && (() => {
                      const fileUrl =
                        typeof option.attachment === "string"
                          ? option.attachment
                          : option.attachment?.url;
                      console.log();

                      if (!fileUrl) return null;

                      const fileType = fileUrl.split(".").pop().toLowerCase();
                      const isImage = ["jpg", "jpeg", "png"].includes(fileType);
                      const isVideo = ["mp4", "mov"].includes(fileType);
                      const isPdf = fileType === "pdf";
                      const fileIcon =
                        iconData?.find((i) => i.extension === fileType)?.icon ||
                        "/images/file_icon.png";

                      const fullUrl = fileUrl.startsWith("http")
                        ? fileUrl
                        : `${IP}${fileUrl}`;

                      return (
                        <div className="d-flex flex-row align-items-center me-3">
                          {/* ===== Preview ===== */}
                          {isImage ? (
                            <ZoomableImage src={option.attachment} />
                          ) : isVideo ? (
                            <video
                              src={fullUrl}
                              style={{
                                width: "60px",
                                height: "50px",
                                borderRadius: "6px",
                                marginBottom: "5px",
                              }}
                              controls
                            />
                          ) : isPdf ? (
                            <div
                              onClick={() => handleClickforpdf(fileUrl)}
                              style={{
                                width: "100px",
                                height: "50px",
                                background: "#f5f5f5",
                                borderRadius: "6px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "6px 0px"
                              }}
                            >
                              <img
                                src={fileIcon}
                                alt="pdf"
                                style={{ width: "24px", height: "24px" }}
                              />
                              <div className="hw_default_attach_name">
                                <span>
                                  {truncate(option.attachment?.replace(/^[^_]*_/, ""), 15)}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <a
                              href={`https://docs.google.com/gview?url=${encodeURIComponent(
                                fullUrl
                              )}&embedded=true`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ textDecoration: "none" }}
                            >
                              <div
                                style={{
                                  width: "100px",
                                  height: "50px",
                                  background: "#f5f5f5",
                                  borderRadius: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={fileIcon}
                                  alt="file"
                                  style={{ width: "24px", height: "24px" }}
                                />
                              </div>
                            </a>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                </>
              )
            })}
        </div>
      </div>
      {
        mideaviewer && (
          <PdfViewer
            closeMideaviewer={setMideaviewer}
            attachment={responseAttach}
          />
        )
      }
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>

                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>

                    <img
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
